import { BACKEND_URL } from "../../constants/ApplicationConstants";

export function loginURL() {
    return BACKEND_URL + `/api/v1/auth/login`;
}

export function registerURL() {
    return BACKEND_URL + `/api/v1/auth/register`;
}